import enCa from 'cldr-data/main/en/ca-gregorian.json';
import enCurrency from 'cldr-data/main/en/currencies.json';
import enNumbers from 'cldr-data/main/en/numbers.json';
import nlCa from 'cldr-data/main/nl/ca-gregorian.json';
import nlCurrency from 'cldr-data/main/nl/currencies.json';
import nlNumbers from 'cldr-data/main/nl/numbers.json';
import currencyData from 'cldr-data/supplemental/currencyData.json';
import tags from 'cldr-data/supplemental/likelySubtags.json';
import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
// eslint-disable-next-line @typescript-eslint/no-require-imports
const globalize = require('globalize');

export function loadGlobalize() {
    globalize.load(nlNumbers);
    globalize.load(nlCurrency);
    globalize.load(nlCa);

    globalize.load(enNumbers);
    globalize.load(enCurrency);
    globalize.load(enCa);

    globalize.load(tags);
    globalize.load(numberingSystems);
    globalize.load(currencyData);
}
